export const campaignState = {
  OPEN: 'open',
  CLOSED: 'closed',
};

export const boxSubscriptionCompletionStatus = {
  PENDING: 'PENDING',
  WAITING_FOR_PAYMENT: 'WAITING_FOR_PAYMENT',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
};

export const getCustomizeOpenStatus = (boxData) => {
  if (boxData && boxData.currentBox) {
    if (!!boxData.currentBox.sku && boxData.currentBox.sku.includes('-ED-')) {
      return campaignState.CLOSED;
    }
    const now = Date.now();
    if (
      boxData.season &&
      now <= new Date(boxData.season.customizeEndDate) &&
      now >= new Date(boxData.season.customizeStartDate)
    ) {
      return campaignState.OPEN;
    }
  }

  return campaignState.CLOSED;
};

export const getCampaignOpenStatus = (campaign) =>
  campaign && campaign.userAccess ? campaignState.OPEN : campaignState.CLOSED;

export const getNMCOpenStatus = () => campaignState.OPEN;

export const getBeautyBoxOpenStatus = (subscription) => {
  if (
    subscription &&
    subscription.customizeCompletionStatus === boxSubscriptionCompletionStatus.PENDING
  ) {
    return campaignState.OPEN;
  }

  return campaignState.CLOSED;
};
